// interfaces/types
import type { AccessoryElement } from '@makemydeal/dr-platform-types';

export const calculateAccessoriesTotalAmount = (accessories: AccessoryElement[]) => {
    return accessories.reduce((currentTotal, accessory) => currentTotal + accessory.amount, 0);
};
